var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"project-briefing-edit","toptitle":"Briefing bearbeiten","title":_vm.projectBriefing.name,"width":400}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('project-briefing-form',{attrs:{"projectBriefing":_vm.projectBriefing,"type":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }